import { gql, TypedDocumentNode } from '@apollo/client';
import type { Product } from '../models/Product';

export const GET_PRODUCTS_QUERY: TypedDocumentNode<{ products: Product[] }, { filter?: {} }> = gql`
  query GetProducts($filter: ProductFilterInput) {
    products(where: $filter, order: { name: ASC }) {
      id,
      name,
      sku,
      costPerUnit,
      customerId,
      customer {
        id,
        name
      },
      costingType,
      hasInventory,
      items {
        id,
        itemId,
        item {
          id,
          name
        },
        quantity,
        notes,
        averageItemCostPerBatchPound,
        averageItemCostPerStandardBatch
      },
      ingredientItems {
        id,
        itemId,
        item {
          id,
          name
        },
        quantity,
        notes,
        averageItemCostPerBatchPound,
        averageItemCostPerStandardBatch
      },
      packagingItems {
        id,
        itemId,
        item {
          id,
          name
        },
        quantity,
        notes,
        averageItemCostPerBatchPound,
        averageItemCostPerStandardBatch
      },
      matchingProductId,
      matchingProduct {
        id,
        name
      },
      totalItemQuantity,
      totalAverageItemCostPerBatchPound,
      totalAverageItemCostPerStandardBatch,
      bulkPricingMarkupLineItems(order: { pounds: ASC }) {
        id,
        pounds,
        markup
      },
      totalQuantityOnHand {
        key,
        value
      }
    }
  }
`;

export const GET_PRODUCT_BY_ID_QUERY: TypedDocumentNode<{ product: Product }, { id: number }> = gql`
  query GetProductById($id: Int!) {
    product: productById(id: $id) {
      id,
      name,
      sku,
      costPerUnit,
      customerId,
      customer {
        id,
        name
      },
      costingType,
      hasInventory,
      items {
        id,
        itemId,
        item {
          id,
          name,
          averageCostPerUnit
        },
        quantity,
        notes,
        averageItemCostPerBatchPound,
        averageItemCostPerStandardBatch
      },
      ingredientItems {
        id,
        itemId,
        item {
          id,
          name,
          averageCostPerUnit
        },
        quantity,
        notes,
        averageItemCostPerBatchPound,
        averageItemCostPerStandardBatch
      },
      packagingItems {
        id,
        itemId,
        item {
          id,
          name,
          averageCostPerUnit
        },
        quantity,
        notes,
        averageItemCostPerBatchPound,
        averageItemCostPerStandardBatch
      },
      matchingProductId,
      matchingProduct {
        id,
        name
      },
      totalItemQuantity,
      totalAverageItemCostPerBatchPound,
      totalAverageItemCostPerStandardBatch,
      bulkPricingMarkupLineItems(order: { pounds: ASC }) {
        id,
        productId,
        pounds,
        markup
      },
      batches {
        id,
        dateTimeCreated,
        amount,
        lotNumber,
        totalCost,
        product {
          id,
          name
        },
        consumedInventoryItems {
          id,
          inventoryItemId,
          inventoryItem {
            id,
            purchaseOrderId,
            purchaseOrder {
              id,
              dateTimePurchased
            },
            itemId,
            item {
              id,
              name
            },
            vendorId,
            vendor {
              id,
              name
            },
            lotNumber
          },
          quantityNeeded,
          quantityUsed,
          totalProductBatchQuantity,
          totalItemCost
        }
      },
      productInventoryItems {
        id,
        packagingType,
        quantityOnHand,
        batchId,
        batch {
          id,
          lotNumber
        }
      },
      totalQuantityOnHand {
        key,
        value
      }
    }
  }
`;
